import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
    selector: 'password-dialog',
    templateUrl: './password-dialog.component.html',
    styleUrls: ['./password-dialog.component.scss']
})
export class PasswordDialogComponent extends BaseWithBundleComponent implements OnInit {

    public password: string;

    constructor(public dialogRef: MatDialogRef<PasswordDialogComponent>,
                protected componentServiceBundle: ComponentServiceBundle,
                @Inject(MAT_DIALOG_DATA) public data: { processId: string }) {
        super(componentServiceBundle);
        this._idPrefix = 'password_dialog.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public savePassword(): void {
        this.authenticationService.changeUserPassword(this.data.processId, this.password)
                                  .subscribe(result => {
            this.showSimpleConfirmSnackbar(marker('login.recover_password.message.success'), 5000);
            this.dialogRef.close();
        }, err => {
            this.showSimpleErrorSnackbar(marker('login.recover_password.message.error'), 5000);
        });
    }
}
